import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";

import { ContainerDiv } from "../Container/styles";
import {
  FooterFooter,
  FooterPrivacidadeDiv,
  FooterSocialNetworksDiv,
  FooterAssinaturaDiv,
} from "./styles";

import { ReactComponent as AssinaturaSirius } from "../../assets/icons/sirius.svg";
import { items } from "./items";

// footer
const Footer: FC<any> = (lang?) => {
  const { t } = useTranslation();

  // render
  return (
    <FooterFooter>
      <ContainerDiv>
        <span className="copyright-text">{t("footer.copyright")}</span>

        <FooterPrivacidadeDiv>
          <a href={t('footer.link_cookies')} target="_blank" className="link">
            {t("footer.cookies")}
          </a>
          <a href={t('footer.link_privacidade')} target="_blank" className="link">
            {t("footer.privacidade")}
          </a>
          <a href={t('footer.link_etica_e_conduta')} target="_blank" className="link">
            {t("footer.etica_e_conduta")}
          </a>

          <FooterSocialNetworksDiv>
          {items &&
            items.map(({ href, icon }, index: number) => (
              <a
                className="link"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                key={index}
              >
                <span className={`icon ${icon}`}></span>
              </a>
            ))}
          </FooterSocialNetworksDiv>
        </FooterPrivacidadeDiv>

        <FooterAssinaturaDiv>
          <a className="assinatura-wrapper" href="https://www.sirius.com.br?utm_source=site+3rpetroleum&utm_medium=link">
            <AssinaturaSirius/>
          </a>
        </FooterAssinaturaDiv>
      </ContainerDiv>
    </FooterFooter>
  );
};

export default Footer;
